import { NotificationConfig } from '~/actions/triggers/types';
import { hexToRgb } from '~/helpers/converters/hexToRgb';

const mobileWidth = window.screen.width;
const widgetWidth = mobileWidth - 20;
const ratio = widgetWidth / mobileWidth;

export const notificationMobileStyles =
  (prefix: string = '', iterator: number = 0, configuration: NotificationConfig) => `
.${prefix}notification_with_wheel_mobile_${iterator} {
  overflow: initial !important;
  max-width: 344px;
  width: 344px !important;
  top: calc(100% - 430px) !important;
  animation-name: ${prefix}notification_with_wheel_mobile_upside;
  animation-duration: .5s;
  position: absolute !important;
}

.${prefix}notification_with_wheel_mobile_${iterator}.${prefix}adaptation__box__extraHTML {
  transform: matrix(${ratio}, 0, 0, ${ratio}, -${(widgetWidth) / 2}, 0) !important;

}

@keyframes ${prefix}notification_with_wheel_mobile_upside {
  from {
    top: calc(100% + 480px);
    animation-timing-function: linear;
  }

  to {
    top: calc(100% - 480px);
    animation-timing-function: linear;
  }
}

.${prefix}notification_with_wheel_mobile_${iterator}:hover {
  top: 0px;
}

.${prefix}notification_with_wheel_mobile_${iterator} .${prefix}mobile_wheel_filler {
  position: relative;
  height: 200px;
}

.${prefix}notification_with_wheel_mobile_${iterator} .${prefix}wheel_notification_mobile {
  position: relative;
  top: 0;
  transform: rotate(-90deg);
}

.${prefix}notification_with_wheel_mobile_${iterator}  .${prefix}notification__coupon > .${prefix}notification__coupon-text._hidden {
  clip-path: initial !important;
}

.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body {
  min-height: 250px;
  justify-content: center;
}

.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body >
.${prefix}notification__title {
  font-weight: 700;
  font-size: 26px !important;
  line-height: 22px;
  margin-bottom: 12px !important;
}

.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body >
.${prefix}notification__message {
  font-weight: 400;
  font-size: 18px !important;
  line-height: 22px;
  margin-bottom: 12px !important;
}

.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body >
.${prefix}notification__button {
  font-weight: 400;
  font-size: 20px !important;
  line-height: 23px;
  width: 296px !important;
  min-width: 296px !important;
  height: 48px;
}

.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body >
.${prefix}notification__coupon {
  font-weight: 400;
  font-size: 22px !important;
  line-height: 23px;
  width: 296px !important;
  min-width: 296px !important;
  outline: none;
  border-radius: 8px;
  height: 48px;
  border: ${
    configuration?.couponWithBorder
      ? `${configuration?.couponBorderWidth}px dashed ${hexToRgb(
        configuration?.couponBorderColor,
        configuration?.couponBorderOpacity
      )}`
      : 'none'
}
}

.${prefix}notification_with_wheel_mobile_${iterator} > .${prefix}notification__body >
.${prefix}notification__coupon > .${prefix}notification__coupon-text {
  font-size: 22px !important;
  margin-top: 2px;
}

`;
